'use client';

import { useEffect } from 'react';

import { usePathname } from 'next/navigation';
import Script from 'next/script';

import { getLogger } from '@kit/shared/logger';

// Declare global _hsq type
declare global {
  interface Window {
    _hsq?: any[];
  }
}

export function HubSpotTracking() {
  const pathname = usePathname();
  const hubspotId = process.env.NEXT_PUBLIC_HUBSPOT_PORTAL_ID;

  // Track page views on route changes
  useEffect(() => {
    if (typeof window === 'undefined') return;

    // Initialize HubSpot queue if it doesn't exist
    var _hsq = (window._hsq = window._hsq || []);

    // Track page view
    _hsq.push(['setPath', pathname]);
    _hsq.push(['trackPageView']);
  }, [pathname, hubspotId]);

  useEffect(() => {
    if (!hubspotId) {
      const logError = async () => {
        const logger = getLogger();
        logger.error('HubSpot Portal ID not found in environment variables');
      };
      void logError();
    }
  }, [hubspotId]);

  if (!hubspotId) {
    return null;
  }

  return (
    <Script
      type="text/javascript"
      id="hs-script-loader"
      async
      defer
      src={`//js-na1.hs-scripts.com/${hubspotId}.js`}
      strategy="afterInteractive"
    />
  );
}
